const IconMenuClose = (): JSX.Element => {
  return (
    <>
      <path
        fill="currentColor"
        d="M8.7,8.2c0.4-0.4,1.1-0.4,1.6,0l5.9,5.9l5.9-5.9c0.4-0.4,1.1-0.4,1.6,0c0.4,0.4,0.4,1.1,0,1.6l-5.9,5.9l5.9,5.9  c0.4,0.4,0.4,1.1,0,1.6s-1.1,0.4-1.6,0l-5.9-5.9l-5.9,5.9c-0.4,0.4-1.1,0.4-1.6,0c-0.4-0.4-0.4-1.1,0-1.6l5.9-5.9L8.7,9.8  C8.3,9.3,8.3,8.6,8.7,8.2z"
      />
    </>
  );
};

export default IconMenuClose;
